import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { ParquetSink } from 'app/model/pipeline/copysink/parquet.sink';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from '../copysource/format-read-settings/format-read-settings.util';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ParquetSink),
    asynchronous: true,
    adapts: {
        type: '*',
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class ParquetSinkAdapter extends CopySinkAdapter<ParquetSink, Model.ParquetSink> {
    protected override async _toResource(model: ParquetSink): Promise<Model.ParquetSink> {
        const result: Model.ParquetSink = {
            type: 'ParquetSink'
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        await convertFormatSettingsToResource(model.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(resource: Model.ParquetSink, owner: Activity): Promise<ParquetSink> {
        const result = Owned.create<ParquetSink>(Metamodel.modelFor(ParquetSink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        await convertFormatSettingsToModel(resource.formatSettings, result, this.context);

        return result;
    }
}
